var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"c-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":_vm.viewBox,"aria-label":_vm.icon.name,"role":"img"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('g',{attrs:{"fill":_vm.fill,"stroke":_vm.stroke},domProps:{"innerHTML":_vm._s(_vm.icon.path)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }